import { render, staticRenderFns } from "./ListQueryAnswerTypes.vue?vue&type=template&id=8e4c7554"
import script from "./ListQueryAnswerTypes.vue?vue&type=script&lang=js"
export * from "./ListQueryAnswerTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports